import React, { useState } from 'react';
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const ConfirmSignUp: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      await confirmSignUp({
        username: email,
        confirmationCode: code
      });
      navigate('/login', { state: { message: 'Your account has been confirmed! Please sign in.' } });
    } catch (error: any) {
      console.error('Error confirming sign up:', error);
      setError(error.message || 'An error occurred during confirmation');
      setLoading(false);
    }
  };

  const handleResendCode = async () => {
    setError(null);
    
    try {
      await resendSignUpCode({
        username: email
      });
      alert('A new verification code has been sent to your email');
    } catch (error: any) {
      console.error('Error resending code:', error);
      setError(error.message || 'Failed to resend verification code');
    }
  };

  // If no email is provided in location state, redirect to signup
  if (!email) {
    return (
      <div className="card">
        <h2 className="card-title">Missing Email</h2>
        <p>Please go back to the sign up page to start the registration process.</p>
        <Link to="/signup" className="btn">Go to Sign Up</Link>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 className="card-title">Confirm Your Account</h2>
      <p>A verification code has been sent to {email}. Please enter it below.</p>
      
      {error && <div className="error-message">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="code" className="form-label">Verification Code:</label>
          <input
            id="code"
            type="text"
            className="form-input"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </div>
        
        <button 
          type="submit" 
          className="btn" 
          disabled={loading}
        >
          {loading ? 'Confirming...' : 'Confirm Account'}
        </button>
      </form>
      
      <p>
        Didn't receive a code?{' '}
        <button 
          onClick={handleResendCode} 
          className="btn-link"
          style={{ background: 'none', border: 'none', color: '#007bff', textDecoration: 'underline', cursor: 'pointer', padding: 0, fontSize: '1rem' }}
        >
          Resend Code
        </button>
      </p>
      
      <p>
        <Link to="/signup">Return to Sign Up</Link>
      </p>
    </div>
  );
};

export default ConfirmSignUp;
